{
  "name": "erp-frontend",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration=development",
    "start:prod": "ng serve --configuration=production",
    "build:dev": "ng build --configuration=development",
    "build:prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@10.9.3",
  "dependencies": {
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@angular/service-worker": "^21.2.18",
    "@some-angular-utils/modal": "^0.0.3",
    "@some-angular-utils/table": "0.1.30",
    "awesome-notifications": "^3.1.3",
    "html2canvas": "^1.4.1",
    "idb": "^8.0.3",
    "jspdf": "^4.2.1",
    "laravel-echo": "^2.4.0",
    "pusher-js": "^8.6.0",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.18",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "^21.0.0",
    "@tailwindcss/postcss": "^4.1.12",
    "@types/awesome-notifications": "^3.1.8",
    "fake-indexeddb": "^6.2.6",
    "jsdom": "^27.1.0",
    "postcss": "^8.5.3",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
